// extracted by mini-css-extract-plugin
export default {"bookNowBtn":"BookNowBtn_bookNowBtn__jPURF","change-color-on-hover":"BookNowBtn_change-color-on-hover__gyn96","button":"BookNowBtn_button__f-Il+"};